import { HeaderCell, Row } from './InterestTableDTO';
import { ExtraInterest } from '../../Response/Interest/InterestPerProduct';

export interface InterestPerProductTableState {
    error: boolean;
    data: Row[];
    headers: HeaderCell[];
    loading: boolean;
    extraInterest: ExtraInterest;
    messages: string[];
}

export const INITIAL_TABLE_STATE: InterestPerProductTableState = {
    error: false,
    data: [],
    headers: [],
    loading: true,
    extraInterest: {},
    messages: [],
};
